import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout      from './components/Layout';
import Login       from './pages/Login';
import Dashboard   from './pages/Dashboard';
import Orders      from './pages/Orders';
import Drivers     from './pages/Drivers';
import Stores      from './pages/Stores';
import Analytics   from './pages/Analytics';
import Users       from './pages/Users';
import Leads       from './pages/Leads';
import Testimonials from './pages/Testimonials';
import Settings    from './pages/Settings';

function PrivateRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',fontSize:14,color:'#5B7BA8' }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && !['superadmin','admin'].includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index                  element={<Dashboard />} />
        <Route path="orders"          element={<Orders />} />
        <Route path="drivers"         element={<Drivers />} />
        <Route path="stores"          element={<Stores />} />
        <Route path="analytics"       element={<Analytics />} />
        <Route path="leads"           element={<Leads />} />
        <Route path="testimonials"    element={<Testimonials />} />
        <Route path="users"           element={<PrivateRoute adminOnly><Users /></PrivateRoute>} />
        <Route path="settings"        element={<Settings />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}
